import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=0212be2b&scoped=true&"
import script from "./MemberProfile.vue?vue&type=script&lang=js&"
export * from "./MemberProfile.vue?vue&type=script&lang=js&"
import style0 from "./MemberProfile.vue?vue&type=style&index=0&id=0212be2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212be2b",
  null
  
)

export default component.exports